module.exports = __webpack_public_path__ + "img/zizhi25.b42deb86.png";